import React, { useState, useCallback, useEffect } from "react";
import { Container, SideBarContent, ItemMenu } from "./style";
import Logo from "../../../../assets/show_music_logo.svg";
import { FiMenu } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useAuth } from "../../../../hooks/Auth";

export const SideBar: React.FC = () => {
  useEffect(() => {}, []);
  const [activeMenu, setActiveMenu] = useState("users");
  const { SignOut } = useAuth();

  return (
    <>
      <Container>
        <SideBarContent>
          <img src={Logo} alt="Show Music Admin" />
          <ItemMenu active={activeMenu === "users"}>
            <Link to="/users" onClick={() => setActiveMenu("users")}>
              <p>Usuários</p>
            </Link>
          </ItemMenu>
          <ItemMenu active={activeMenu === "ContractCanceled"}>
            <Link
              to="/contractCanceled"
              onClick={() => setActiveMenu("ContractCanceled")}
            >
              <p>Show Cancelados</p>
            </Link>
          </ItemMenu>
          <ItemMenu active={activeMenu === "logout"}>
            <Link
              to="/"
              onClick={() => {
                SignOut();
              }}
            >
              <p>Sair</p>
            </Link>
          </ItemMenu>
        </SideBarContent>
      </Container>
    </>
  );
};
